import request from '../request';

export function getUsers(params) {
  return request({
    url:'management/users',
    method:'get',
    params,
  })
}

export function getUserID(id) {
  return request({
    url: `management/users/${id}`,
    method: "get"
  })
}

export function getDriver() {
  return request({
    url: "management/users?driver=true",
    method: "get"
  })
}

export function postUser(data) {
  return request({
    url: "management/users",
    method: "post",
    data
  })
}

export function putUser(data) {
  return request({
    url: `management/users/${data.id}`,
    method: "put",
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `management/users/${id}`,
    method: "delete",
  })
}